import { render, staticRenderFns } from "./StartNewRealisation.vue?vue&type=template&id=d3c29854"
import script from "./StartNewRealisation.vue?vue&type=script&lang=js"
export * from "./StartNewRealisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports